export interface RouterState {
  nextUrl: string
}

export const routerMutationTypes = {
  SET_NEXT_URL: 'SET_NEXT_URL',
  RESET_NEXT_URL: 'RESET_NEXT_URL'
}
